import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <p className="footer__text">&copy; 2026 Saad Lakdawala</p>
        <div className="footer__links">
          <a 
            href="https://github.com/Saad259" 
            className="footer__link" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            GitHub
          </a>
          <a 
            href="https://www.linkedin.com/in/saad-lakdawala-2790b7248/" 
            className="footer__link" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
